import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { useDevice } from 'seagull';
import { useHomePageRoutesByUrl } from '~/hooks/useHomePageRoutesByUrl';
import { useRootDevice } from '~/providers/DeviceProvider';
export function useIsMobileForHomePage() {
    const { isMobileDevice } = useDevice();
    const { isMobileDevice: isMobileDeviceFromRoot } = useRootDevice();
    const location = useLocation();
    const homePagePages = useHomePageRoutesByUrl();
    return useMemo(()=>{
        if (isMobileDevice) return true;
        if (!isMobileDeviceFromRoot) return false;
        const page = homePagePages[location.pathname];
        if (!(page === null || page === void 0 ? void 0 : page.supportsMobileDevice)) return false;
        return true;
    }, [
        isMobileDevice,
        isMobileDeviceFromRoot,
        homePagePages,
        location.pathname
    ]);
}
